import { useQueueWorkflowStore } from "@elixir/stores";
import { InputField } from "ui";
import ApplyFiltersView from "../../apply-filters-view";
import { useEffect } from "react";

const EditQueue = () => {
  const setViewName = useQueueWorkflowStore((state) => state.setViewName);
  const viewName = useQueueWorkflowStore((state) => state.viewName);
  const viewData = useQueueWorkflowStore((state) => state.viewData);

  useEffect(() => {
    if (viewData) {
      setViewName(viewData.name);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewData]);

  return (
    <div className="dr-flex dr-flex-col dr-h-full -dr-mx-16 dr-relative">
      <div className="dr-px-16 dr-pb-16 dr-border-b dr-border-darwin-neutral-200">
        <InputField
          onChange={(e) => setViewName(e.target.value)}
          value={viewName}
        />
      </div>
      <div
        className="dr-overflow-scroll"
        style={{ height: `calc(100vh - 210px)` }}
      >
        <ApplyFiltersView />
      </div>
    </div>
  );
};

export default EditQueue;
